import React, { useState, useMemo } from "react";
import { Modal } from "@iq/models";
import {deleteDeal, getDealByID} from "../../services/contact_service"


function UpdateDealModal({isOpen, onClose, deal, onDelete}) {


   const [deleting, setDeleting] = useState(false);
   

   if(!deal) {
        return null;
   }


   const handleDelete = async () => {
        if (!deal?.id) {
        console.error("No deal ID provided");
        onClose();
        return;
        }

        if (!window.confirm(`WARNING: This will permanently delete the deal "${deal.title}" and all associated data. This action cannot be undone.`)) {
        return;
        }

        setDeleting(true);

        try {
            const dealData = await getDealByID(deal.id);
            console.log(dealData);
        console.log("Deleting deal:", deal.id);
        

        await deleteDeal(deal.id);
        
        // Success - remove from UI
        if (onDelete) {
            await onDelete(deal.id);
        }
        onClose();
        alert("Deal deleted successfully!");
        
        } catch (error) {
        console.error("Error deleting deal:", error);
    
        alert("Deal will be removed from the list. Please refresh if it reappears.");
        if (onDelete) {
            await onDelete(deal.id);
        }
        onClose();
        } finally {
        setDeleting(false);
        }
    };
   const actionButtons = [
    {
           key: "cancel",
           text: "Cancel",
           type: "button",
           disabled: deleting,
           onClick: onClose
       },
       {
           key: "delete",
           text: deleting ? "Deleting..." : "Delete deal",
           type: "button",
           color: "danger",
           onClick: handleDelete
       },
   ];


   return (
       <Modal
       isOpen={isOpen}
       title="Delete Deal"
       onClose={onClose}
       overlayClassName="modal-backdrop"
       contentClassName="modal-card"
       actionButtons={actionButtons}
       >
           <div className="modal-body">
               <h4>Would you like to delete the deal "{deal.title}"? Once deleted, this deal will be removed from the system and all associated data will be lost. This action cannot be undone.</h4>
           </div>
       </Modal>
   );
}


export default UpdateDealModal;